<template>
  <div v-if="canExport">
    <json-excel
      class="btn btn-default"
      :name="nameFile"
      :title="title"
      :fields="json_fields"
      sortField="total_time"
      :escapeCsv="true"
      type="csv"
      :before-generate="beforeGenerate"
      :before-finish="beforeFinish"
      :fetch="doExport"
    >
      <el-tooltip placement="top" :content="$t('information.export_report_button')">
        <chip class="export-lesson" v-loading.fullscreen.lock="exportLoading">
          {{ $t("common.export_report") }}
        </chip>
      </el-tooltip>
    </json-excel>
  </div>
</template>

<script>
import showNoReportDataWarning from "@/components/common/mixins/noReportData";
import { isSessionExpireError } from "@/utils/sessionExpireErr";
import Chip from "@/components/common/Chip";
import JsonExcel from "@/components/lib/JsonExcel";
import { format, toDate, startOfMonth, differenceInDays } from "date-fns";
import { mapGetters, mapActions, mapState } from "vuex";
import { pathOr, length, join, prop, compose, concat, __ } from "ramda";
export default {
  mixins: [showNoReportDataWarning],
  components: {
    Chip,
    JsonExcel,
  },
  props: {
    startDate: {
      default: () => startOfMonth(Date.now()),
    },
    endDate: {
      default: () => toDate(Date.now()),
    },
    scope: {
      default: "daily",
    },
    canExport: {
      default: false,
    },
    assessmentType: {
      type: String,
      default: "general",
    },
  },
  data() {
    return {
      json_fields: {
        "Learner Name": "student_name",
        "Learner Email": "student_email",
        "Time Studied (Total)": "total_time",
        "Lessons Completed (Total)": "lession_practice",
        "Days Active (Total)": "days_practice",
        "Learner Engagement Rate": "learner_engagement_rate",
        "Avg. Study Time (Per Day)": "number_of_minutes_perDay",
        "Avg. Study Time (Per Active Day)": "number_of_minutes_per_active_day",
        "Avg. Lessons (Per Day)": "number_lesson_practice_perday",
        "Avg. Lessons (Per Active Day)": "number_lesson_practice_per_active_day",
        "First Assessment Date": "first_date_assessment_test",
        "First Assessment Score": "first_assessment_test_eps",
        "First EPS Score": "First_EPS",
        "Last Assessment Date": "last_date_assessment_test",
        "Last Assessment Score": "assessment_test_eps",
        "Last EPS Score": "Last_EPS",
        "Assessment Score Change": "assessment_score_change",
        "EPS Improvement": "eps_improvement",
        "Last Active": "last_active",
      },
      exportLoading: false,
    };
  },
  destroyed() {
    this.$store.dispatch("classes/resetExportLessonData");
  },
  methods: {
    getAllExportData(options) {
      return this.getExportLessonData(options).catch(err => {
        if (!isSessionExpireError(err)) this.showNoReportDataWarning();
      });
    },
    ...mapActions({ getCurrentClassAllUsers: "classes/getCurrentClassAllUsers" }),
    ...mapActions("classes", ["getExportLessonData"]),
    async doExport() {
      const MAX_BULK_REQUEST = 300;
      try {
        if (!length(this.exportLessonData)) {
          await this.getCurrentClassAllUsers();
          for (var i = 0; i < this.currentClassAllStudent.length; i += MAX_BULK_REQUEST) {
            const studentRequests = this.currentClassAllStudent.slice(i, i + MAX_BULK_REQUEST).map(studentClass => {
              let student = studentClass["user"];
              let options = {
                student: student,
                from: this.startDate,
                to: this.endDate,
                scope: this.scope,
                assessment_type: this.assessmentType,
              };
              return this.getAllExportData(options);
            });
            await Promise.all(studentRequests).catch(err => {
              if (!isSessionExpireError(err)) this.showNoReportDataWarning();
            });
          }
        }
        try {
          this.$gtag.event(`${document.title}-export report`, {
            category: `Export`,
            label: `Export Report`,
          });
        } catch (error) {
          error;
        }
        return this.exportLessonData.map(data => {
          return {
            ...data,
          };
        });
      } catch (error) {
        return error;
      }
    },
    beforeGenerate() {
      return (this.exportLoading = true);
    },
    beforeFinish() {
      return (this.exportLoading = false);
    },
  },
  computed: {
    ...mapState("classes", ["exportLessonData"]),
    ...mapGetters({
      getCurrentClass: "classes/getCurrentClass",
      currentClassAllStudent: "classes/getCurrentClassAllStudent",
    }),
    ...mapGetters("students", ["paginateStudents"]),
    title() {
      const formatedStartDate = format(new Date(this.startDate), "dd MMM yyyy");
      const formatedEndDate = format(new Date(this.endDate), "dd MMM yyyy");
      let titleTime = `${formatedStartDate} - ${formatedEndDate}`;
      const dateDiff = differenceInDays(this.endDate, this.startDate) + 1;
      return [
        this.$t("common.class_time_export_title", [this.getCurrentClass.name]),
        titleTime,
        `duration: ${dateDiff} days`,
      ];
    },
    nameFile: compose(concat(__, ".csv"), join(" "), prop("title")),
  },
  watch: {
    assessmentType: {
      immediate: true,
      handler(newValue) {
        this.$store.dispatch("classes/resetExportLessonData");
        if (newValue == "sgd-assessment") delete this.json_fields["Score improvement"];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";
.export-lesson {
  margin-right: 10px;
  padding: 11px 11px;
}
</style>
